(() => {
  if (customElements.get('trust-strip')) return;

  class TrustStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-trust-track]');
      this.prevFade = this.querySelector('[data-trust-fade="prev"]');
      this.nextFade = this.querySelector('[data-trust-fade="next"]');
      this.querySelector('[data-trust-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-trust-next]')?.addEventListener('click', () => this.step(1));
      this.sync = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.track.addEventListener('scroll', this.sync, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.sync);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.sync);
      }
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.sync);
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflow = max > 8;
      this.prevFade.hidden = !(overflow && this.track.scrollLeft > 2);
      this.nextFade.hidden = !(overflow && this.track.scrollLeft < max - 2);
    }

    step(direction) {
      const items = Array.from(this.track.children);
      if (!items.length) return;
      const base = this.track.getBoundingClientRect().left;
      const positions = items.map((item) => this.track.scrollLeft + (item.getBoundingClientRect().left - base));
      let index = positions.findIndex((position) => position >= this.track.scrollLeft - 4);
      if (index < 0) index = items.length - 1;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const padding = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
      let target = positions[Math.max(0, Math.min(items.length - 1, index + direction))] - padding;
      target = Math.max(0, Math.min(max, target));
      if (direction > 0 && target > max - 40) target = max;
      if (direction < 0 && target < 40) target = 0;
      const reduced = window.theme?.motion && window.theme.motion() === 'off';
      this.track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
    }
  }

  customElements.define('trust-strip', TrustStrip);
})();
